// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3E0Ynyop8fklUJ {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 4px;\n  background-origin: content-box;\n  background-clip: content-box;\n  background-size: 16px;\n  background-repeat: no-repeat;\n  background-position: 4px 4px;\n  vertical-align: bottom;\n}\n._3K09J3xqj8n-uQ {\n  border-radius: 3px;\n  height: 32px;\n  margin: 0 4px 4px 0;\n  max-width: 400px;\n  padding-left: 32px;\n  position: relative;\n}\n.ATjiijuQ4KooJb {\n  margin-left: 8px;\n}\n.ATjiijuQ4KooJb:empty {\n  display: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardButtonIcon": "_3E0Ynyop8fklUJ",
	"butlerBoardButton": "_3K09J3xqj8n-uQ",
	"newPill": "ATjiijuQ4KooJb"
};
export default ___CSS_LOADER_EXPORT___;
